import { useQuery } from "@tanstack/react-query";

import banners, { baseURLBannersAPI } from "../../services/banners";
import { queryKeys } from "../api/queryKeys";
import { BANNERS_MARKETING_STALE_MS, useBannersToken } from "./useBannersToken";

export interface BannerPopup {
  id: number;
  description: string;
  promotionNumber: number;
  image: string;
  url: string;
  urlType: string;
}

export const useBannerPopups = () => {
  const { data: tokenPayload, isSuccess: tokenReady } = useBannersToken();

  return useQuery<BannerPopup[]>({
    queryKey: queryKeys.bannerPopups,
    enabled: tokenReady && !!tokenPayload?.token && !!baseURLBannersAPI,
    queryFn: async () => {
      const { data } = await banners.get<BannerPopup[]>(
        "/popUp/getCurrentPopUps",
        {
          headers: {
            Authorization: `Bearer ${tokenPayload!.token}`,
          },
        }
      );

      return data;
    },
    staleTime: BANNERS_MARKETING_STALE_MS,
  });
};
